import BaseService from "src/packages/BaseService";

export default class CityService extends BaseService {
	static get className() {
		return "city";
	}
};
